import MarketingDocumentQueryParams from 'src/adminPanel/components/pages/it/marketing-documents/MarketingDocumentQueryParams';
import NewLanguageBlock from 'src/adminPanel/entities/templateAdmin/NewLanguageBlock';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import { action } from '../actions';

export const CREATE_LANGUAGE_BLOCK = 'CREATE_LANGUAGE_BLOCK';
export const REQUEST_CREATE_LANGUAGE_BLOCK = 'REQUEST_CREATE_LANGUAGE_BLOCK';
export const SUCCESS_CREATE_LANGUAGE_BLOCK = 'SUCCESS_CREATE_LANGUAGE_BLOCK';
export const FAILURE_CREATE_LANGUAGE_BLOCK = 'FAILURE_CREATE_LANGUAGE_BLOCK';

export const createLanguageBlock = (newLanguageBlock: NewLanguageBlock) =>
    action(CREATE_LANGUAGE_BLOCK, { newLanguageBlock });
export const requestCreateLanguageBlock = () => action(REQUEST_CREATE_LANGUAGE_BLOCK);
export const requestCreateLanguageBlockSuccess = (response: any) => action(SUCCESS_CREATE_LANGUAGE_BLOCK, { response });
export const requestCreateLanguageBlockFailure = (error: any) => action(FAILURE_CREATE_LANGUAGE_BLOCK, { error });

export const EDIT_LANGUAGE_BLOCK_TRANSLATION = 'EDIT_LANGUAGE_BLOCK_TRANSLATION';
export const REQUEST_EDIT_LANGUAGE_BLOCK_TRANSLATION = 'REQUEST_EDIT_LANGUAGE_BLOCK_TRANSLATION';
export const SUCCESS_EDIT_LANGUAGE_BLOCK_TRANSLATION = 'SUCCESS_EDIT_LANGUAGE_BLOCK_TRANSLATION';
export const FAILURE_EDIT_LANGUAGE_BLOCK_TRANSLATION = 'FAILURE_EDIT_LANGUAGE_BLOCK_TRANSLATION';

export const editLanguageBlockTranslation = (normalizedName: string, languageIso2: string, text: string) =>
    action(EDIT_LANGUAGE_BLOCK_TRANSLATION, { normalizedName, languageIso2, text });
export const requestEditLanguageBlockTranslation = () => action(REQUEST_EDIT_LANGUAGE_BLOCK_TRANSLATION);
export const requestEditLanguageBlockTranslationSuccess = (response: any) =>
    action(SUCCESS_EDIT_LANGUAGE_BLOCK_TRANSLATION, { response });
export const requestEditLanguageBlockTranslationFailure = (error: any) =>
    action(FAILURE_EDIT_LANGUAGE_BLOCK_TRANSLATION, { error });

export const FETCH_TEMPLATE_BY_TEMPLATE_KEY = 'FETCH_TEMPLATE_BY_TEMPLATE_KEY';
export const REQUEST_FETCH_TEMPLATE_BY_TEMPLATE_KEY = 'REQUEST_FETCH_TEMPLATE_BY_TEMPLATE_KEY';
export const SUCCESS_FETCH_TEMPLATE_BY_TEMPLATE_KEY = 'SUCCESS_FETCH_TEMPLATE_BY_TEMPLATE_KEY';
export const FAILURE_FETCH_TEMPLATE_BY_TEMPLATE_KEY = 'FAILURE_FETCH_TEMPLATE_BY_TEMPLATE_KEY';

export const fetchTemplateByTemplateKey = (templateKey: string) =>
    action(FETCH_TEMPLATE_BY_TEMPLATE_KEY, { templateKey });
export const requestFetchTemplateByTemplateKey = () => action(REQUEST_FETCH_TEMPLATE_BY_TEMPLATE_KEY);
export const requestFetchTemplateByTemplateKeySuccess = (response: any) =>
    action(SUCCESS_FETCH_TEMPLATE_BY_TEMPLATE_KEY, { response });
export const requestFetchTemplateByTemplateKeyFailure = (error: any) =>
    action(FAILURE_FETCH_TEMPLATE_BY_TEMPLATE_KEY, { error });

/*Marketing Text Blocks*/
export const FETCH_ALL_LANGUAGE_BLOCKS = 'FETCH_ALL_LANGUAGE_BLOCKS';
export const REQUEST_FETCH_ALL_LANGUAGE_BLOCKS = 'REQUEST_FETCH_ALL_LANGUAGE_BLOCKS';
export const SUCCESS_FETCH_ALL_LANGUAGE_BLOCKS = 'SUCCESS_FETCH_ALL_LANGUAGE_BLOCKS';
export const FAILURE_FETCH_ALL_LANGUAGE_BLOCKS = 'FAILURE_FETCH_ALL_LANGUAGE_BLOCKS';

export const fetchAllLanguageBlocks = (pageable?: PageableQueryParams) =>
    action(FETCH_ALL_LANGUAGE_BLOCKS, { pageable });
export const requestFetchAllLanguageBlocks = () => action(REQUEST_FETCH_ALL_LANGUAGE_BLOCKS);
export const requestFetchAllLanguageBlocksSuccess = (response: any) =>
    action(SUCCESS_FETCH_ALL_LANGUAGE_BLOCKS, { response });
export const requestFetchAllLanguageBlocksFailure = (error: any) =>
    action(FAILURE_FETCH_ALL_LANGUAGE_BLOCKS, { error });

export const FETCH_LANGUAGE_BLOCKS_BY_QUERY = 'FETCH_LANGUAGE_BLOCKS_BY_QUERY';
export const REQUEST_FETCH_LANGUAGE_BLOCKS_BY_QUERY = 'REQUEST_FETCH_LANGUAGE_BLOCKS_BY_QUERY';
export const SUCCESS_FETCH_LANGUAGE_BLOCKS_BY_QUERY = 'SUCCESS_FETCH_LANGUAGE_BLOCKS_BY_QUERY';
export const FAILURE_FETCH_LANGUAGE_BLOCKS_BY_QUERY = 'FAILURE_FETCH_LANGUAGE_BLOCKS_BY_QUERY';

export const fetchLanguageBlocksByQuery = (query: string, pageable: PageableQueryParams) =>
    action(FETCH_LANGUAGE_BLOCKS_BY_QUERY, { query, pageable });
export const requestFetchLanguageBlocksByQuery = () => action(REQUEST_FETCH_LANGUAGE_BLOCKS_BY_QUERY);
export const requestFetchLanguageBlocksByQuerySuccess = (response: any) =>
    action(SUCCESS_FETCH_LANGUAGE_BLOCKS_BY_QUERY, { response });
export const requestFetchLanguageBlocksByQueryFailure = (error: any) =>
    action(FAILURE_FETCH_LANGUAGE_BLOCKS_BY_QUERY, { error });

export const FETCH_LANGUAGE_BLOCKS_BY_TEMPLATE_KEY = 'FETCH_LANGUAGE_BLOCKS_BY_TEMPLATE_KEY';
export const REQUEST_FETCH_LANGUAGE_BLOCKS_BY_TEMPLATE_KEY = 'REQUEST_FETCH_LANGUAGE_BLOCKS_BY_TEMPLATE_KEY';
export const SUCCESS_FETCH_LANGUAGE_BLOCKS_BY_TEMPLATE_KEY = 'SUCCESS_FETCH_LANGUAGE_BLOCKS_BY_TEMPLATE_KEY';
export const FAILURE_FETCH_LANGUAGE_BLOCKS_BY_TEMPLATE_KEY = 'FAILURE_FETCH_LANGUAGE_BLOCKS_BY_TEMPLATE_KEY';

export const fetchLanguageBlocksByTemplateKey = (templateKey: string, pageable: PageableQueryParams) =>
    action(FETCH_LANGUAGE_BLOCKS_BY_TEMPLATE_KEY, { templateKey, pageable });
export const requestFetchLanguageBlocksByTemplateKey = () => action(REQUEST_FETCH_LANGUAGE_BLOCKS_BY_TEMPLATE_KEY);
export const requestFetchLanguageBlocksByTemplateKeySuccess = (response: any) =>
    action(SUCCESS_FETCH_LANGUAGE_BLOCKS_BY_TEMPLATE_KEY, { response });
export const requestFetchLanguageBlocksByTemplateKeyFailure = (error: any) =>
    action(FAILURE_FETCH_LANGUAGE_BLOCKS_BY_TEMPLATE_KEY, { error });

export const FETCH_LANGUAGE_TRANSLATIONS_BY_TEMPLATE_KEY = 'FETCH_LANGUAGE_TRANSLATIONS_BY_TEMPLATE_KEY';
export const REQUEST_FETCH_LANGUAGE_TRANSLATIONS_BY_TEMPLATE_KEY =
    'REQUEST_FETCH_LANGUAGE_TRANSLATIONS_BY_TEMPLATE_KEY';
export const SUCCESS_FETCH_LANGUAGE_TRANSLATIONS_BY_TEMPLATE_KEY =
    'SUCCESS_FETCH_LANGUAGE_TRANSLATIONS_BY_TEMPLATE_KEY';
export const FAILURE_FETCH_LANGUAGE_TRANSLATIONS_BY_TEMPLATE_KEY =
    'FAILURE_FETCH_LANGUAGE_TRANSLATIONS_BY_TEMPLATE_KEY';

export const fetchLanguageTranslationsByTemplateKey = (templateKey: string) =>
    action(FETCH_LANGUAGE_TRANSLATIONS_BY_TEMPLATE_KEY, { templateKey });
export const requestFetchLanguageTranslationsByTemplateKey = () =>
    action(REQUEST_FETCH_LANGUAGE_TRANSLATIONS_BY_TEMPLATE_KEY);
export const requestFetchLanguageTranslationsByTemplateKeySuccess = (response: any) =>
    action(SUCCESS_FETCH_LANGUAGE_TRANSLATIONS_BY_TEMPLATE_KEY, { response });
export const requestFetchLanguageTranslationsByTemplateKeyFailure = (error: any) =>
    action(FAILURE_FETCH_LANGUAGE_TRANSLATIONS_BY_TEMPLATE_KEY, { error });

export const FETCH_TEXT_BLOCK_LANGUAGES = 'FETCH_TEXT_BLOCK_LANGUAGES';
export const REQUEST_FETCH_TEXT_BLOCK_LANGUAGES = 'REQUEST_FETCH_TEXT_BLOCK_LANGUAGES';
export const SUCCESS_FETCH_TEXT_BLOCK_LANGUAGES = 'SUCCESS_FETCH_TEXT_BLOCK_LANGUAGES';
export const FAILURE_FETCH_TEXT_BLOCK_LANGUAGES = 'FAILURE_FETCH_TEXT_BLOCK_LANGUAGES';

export const fetchTextBlockLanguages = () => action(FETCH_TEXT_BLOCK_LANGUAGES, {});
export const requestFetchTextBlockLanguages = () => action(REQUEST_FETCH_TEXT_BLOCK_LANGUAGES);
export const requestFetchTextBlockLanguagesSuccess = (response: any) =>
    action(SUCCESS_FETCH_TEXT_BLOCK_LANGUAGES, { response });
export const requestFetchTextBlockLanguagesFailure = (error: any) =>
    action(FAILURE_FETCH_TEXT_BLOCK_LANGUAGES, { error });

export const FETCH_ALL_REGION_BLOCKS = 'FETCH_ALL_REGION_BLOCKS';
export const REQUEST_FETCH_ALL_REGION_BLOCKS = 'REQUEST_FETCH_ALL_REGION_BLOCKS';
export const SUCCESS_FETCH_ALL_REGION_BLOCKS = 'SUCCESS_FETCH_ALL_REGION_BLOCKS';
export const FAILURE_FETCH_ALL_REGION_BLOCKS = 'FAILURE_FETCH_ALL_REGION_BLOCKS';

export const fetchAllRegionBlocks = (params?: MarketingDocumentQueryParams) =>
    action(FETCH_ALL_REGION_BLOCKS, { params });
export const requestFetchAllRegionBlocks = () => action(REQUEST_FETCH_ALL_REGION_BLOCKS);
export const requestFetchAllRegionBlocksSuccess = (response: any) =>
    action(SUCCESS_FETCH_ALL_REGION_BLOCKS, { response });
export const requestFetchAllRegionBlocksFailure = (error: any) => action(FAILURE_FETCH_ALL_REGION_BLOCKS, { error });

export const FETCH_DOCUMENT_REGIONS_BY_TEMPLATE_KEY = 'FETCH_DOCUMENT_REGIONS_BY_TEMPLATE_KEY';
export const REQUEST_FETCH_DOCUMENT_REGIONS_BY_TEMPLATE_KEY = 'REQUEST_FETCH_DOCUMENT_REGIONS_BY_TEMPLATE_KEY';
export const SUCCESS_FETCH_DOCUMENT_REGIONS_BY_TEMPLATE_KEY = 'SUCCESS_FETCH_DOCUMENT_REGIONS_BY_TEMPLATE_KEY';
export const FAILURE_FETCH_DOCUMENT_REGIONS_BY_TEMPLATE_KEY = 'FAILURE_FETCH_DOCUMENT_REGIONS_BY_TEMPLATE_KEY';

export const fetchDocumentRegionsByTemplateKey = (templateKey: string) =>
    action(FETCH_DOCUMENT_REGIONS_BY_TEMPLATE_KEY, { templateKey });
export const requestFetchDocumentRegionsByTemplateKey = () => action(REQUEST_FETCH_DOCUMENT_REGIONS_BY_TEMPLATE_KEY);
export const requestFetchDocumentRegionsByTemplateKeySuccess = (response: any) =>
    action(SUCCESS_FETCH_DOCUMENT_REGIONS_BY_TEMPLATE_KEY, { response });
export const requestFetchDocumentRegionsByTemplateKeyFailure = (error: any) =>
    action(FAILURE_FETCH_DOCUMENT_REGIONS_BY_TEMPLATE_KEY, { error });

export const FETCH_DOCUMENT_COUNTRIES = 'FETCH_DOCUMENT_COUNTRIES';
export const REQUEST_FETCH_DOCUMENT_COUNTRIES = 'REQUEST_FETCH_DOCUMENT_COUNTRIES';
export const SUCCESS_FETCH_DOCUMENT_COUNTRIES = 'SUCCESS_FETCH_DOCUMENT_COUNTRIES';
export const FAILURE_FETCH_DOCUMENT_COUNTRIES = 'FAILURE_FETCH_DOCUMENT_COUNTRIES';
